import { fabric } from 'fabric';

/**
 * Creates a fresh fabric.Rect instance to use as a clip path.
 *
 * Reusing the same clip path reference across multiple objects causes shared-state
 * rendering issues in some browsers (notably Firefox). Always use this utility
 * instead of assigning a clip path reference directly.
 *
 * @param source - An existing fabric.Rect or object with clip path properties to copy from
 * @returns A new fabric.Rect instance with absolutePositioned: true
 */
export const createClipPathRect = (source: fabric.Rect): fabric.Rect => {
  return new fabric.Rect({
    width: source.width,
    height: source.height,
    left: source.left,
    top: source.top,
    angle: source.angle,
    absolutePositioned: true,
  });
};
